export default __webpack_public_path__ + "static/media/amex.0c0516ad.png";